import type { TourDefinition, TourId } from './types';

/** The dashboard onboarding tour. Step IDs are stable resume keys — never
 *  renumber them. Copy is verbatim from the approved onboarding script. */
export const DASHBOARD_TOUR: TourDefinition = {
  id: 'dashboard',
  steps: [
    {
      id: 'dashboard-metrics',
      target: 'dashboard-metrics',
      placement: 'bottom',
      title: 'Your portfolio at a glance',
      body: 'These tiles track your whole portfolio.',
    },
    {
      id: 'dashboard-portfolio-coverage',
      target: 'dashboard-portfolio-coverage',
      placement: 'top',
      title: 'Mix and coverage',
      body: 'Portfolio Mix breaks your products down by type — device, drug, or biologic. Market Coverage shows how many products have completed agent work in each target market, so you can see where you’re ready and where there are gaps.',
    },
    {
      id: 'dashboard-activity',
      target: 'dashboard-activity',
      placement: 'top',
      scrollIntoView: true,
      title: 'Stay on top of every run',
      body: 'Live agent runs appear under “Running Now,” completed work shows in “Recent Activity,” and any failed run that needs a retry surfaces under “Needs Attention.” Nothing gets lost.',
    },
    {
      id: 'nav-company-account',
      target: 'nav-company-account',
      placement: 'right',
      title: 'Start with your company',
      body: 'Set up your company profile here. This information feeds into your regulatory strategy and submissions.',
    },
    {
      id: 'nav-product-account',
      target: 'nav-product-account',
      placement: 'right',
      title: 'Add your product',
      body: 'Register each device, drug, or biologic here with its intended use, classification details, sterility, and reusability. Every AI agent run is tied to a registered product, so this is your starting point.',
    },
    {
      id: 'nav-agents-header',
      target: 'nav-agents-header',
      placement: 'right',
      title: 'Your AI regulatory team',
      body: 'These five agents do the heavy lifting. Each one produces reviewable, downloadable output.',
    },
    {
      id: 'nav-tools',
      target: 'nav-tools',
      placement: 'right',
      title: 'Your toolbox',
      body: 'Everything from documentation storage, scenarios, and reports. These tools will help you feel confident in your submission.',
    },
    {
      id: 'nav-terms',
      target: 'nav-terms',
      placement: 'right',
      title: 'Your agreements, always available',
      body: 'Review the Terms of Use, Privacy Policy, AI Output Disclaimer, and data agreements anytime.',
    },
    {
      id: 'account-menu',
      target: 'account-menu',
      placement: 'bottom-end',
      title: 'Account and support',
      body: 'Open this menu to manage your profile and settings, invite teammates, browse the FAQ, or reach Help & Support. That’s the tour — you’re ready to go.',
    },
  ],
};

export const TOURS: Record<TourId, TourDefinition> = {
  dashboard: DASHBOARD_TOUR,
};
